export enum DropDownHeaderAccessor {
  Umbrella = 'header-umbrella',
  Organization = 'header-organization',
}
